module.exports = __webpack_public_path__ + "static/gamesop-d3c4df5568c1aacd4a13b3a65c9dc5c9.png";